import { render, staticRenderFns } from "./UserDiseasePredict.vue?vue&type=template&id=43eac4ef&scoped=true"
import script from "./UserDiseasePredict.vue?vue&type=script&lang=js"
export * from "./UserDiseasePredict.vue?vue&type=script&lang=js"
import style0 from "./UserDiseasePredict.vue?vue&type=style&index=0&id=43eac4ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43eac4ef",
  null
  
)

export default component.exports